import { Navigate } from "react-router-dom";
import { useAuth } from "src/contexts/auth.context";
import tessaLogo from "src/assets/tessa-logo.svg";

// Post-logout landing page. First-visit unauthenticated users never land here —
// auth.context redirects them straight to /api/auth/login. This route is only
// reached when the logout flow explicitly navigates the browser to /login.
export function SignedOutScreen() {
  const auth = useAuth();

  if (auth.user) return <Navigate to="/home" replace />;

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-neutral-2">
      <div className="w-[360px] bg-white rounded-lg shadow-md p-10 flex flex-col gap-6 items-center">
        <img src={tessaLogo} alt="Tessa" className="h-[32px]" />
        <p className="text-body-1 text-neutral-6 text-center">
          You've been signed out
        </p>
        <button
          onClick={() => auth.login()}
          className="w-full flex items-center justify-center gap-2 bg-primary-6 text-white
            rounded-sm py-2.5 text-subtitle-2 hover:bg-primary-7 transition-colors"
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
